export const ICON_SIZE_IN_PIXEL = 14;
export const POINT_DESCRIPTION = 'MCF points determine the rank of the user. The higher the points, the higher the rank.'; // @suppress longLineCheck
export const REVIEWER_LINK = 'https://www.mycarforum.com/index.php?app=core&module=members&controller=profile';
export const TEXTBOX_ICON_SRC = '/public/new-cars/icon/textbox.svg';
